import { useState, useEffect } from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';
import { mockVideos, mockCategories } from '@/mocks/videos';

const categoryNameMap: Record<string, string> = {
  dianying: '电影',
  dianshiju: '电视剧',
  zongyi: '综艺',
  dongman: '动漫',
  jilupian: '纪录片',
};

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const navigate = useNavigate();
  const [activeCategory, setActiveCategory] = useState(slug || 'dianying');

  useEffect(() => {
    if (slug) {
      setActiveCategory(slug);
    }
  }, [slug]);

  const filteredVideos = mockVideos.filter((v) => v.category === activeCategory);
  const currentCat = mockCategories.find((c) => c.slug === activeCategory);

  const handleCategoryChange = (newSlug: string) => {
    setActiveCategory(newSlug);
    navigate(`/category/${newSlug}`);
  };

  return (
    <main className="pt-16 min-h-screen">
      <div className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-50">
        <div className="max-w-6xl mx-auto">
          <div className="mb-8">
            <h1 className="text-2xl md:text-3xl font-bold text-foreground-900 mb-2" style={{ fontFamily: "var(--font-heading)" }}>
              {currentCat?.name || '视频分类'}
            </h1>
            <p className="text-sm text-foreground-500">
              {currentCat?.description || '浏览蘑菇视频官网海量内容'}
            </p>
          </div>

          <div className="flex items-center gap-2 mb-8 overflow-x-auto pb-2">
            {mockCategories.map((cat) => (
              <button
                key={cat.slug}
                onClick={() => handleCategoryChange(cat.slug)}
                className={`flex items-center gap-2 px-5 py-2.5 rounded-full text-sm font-medium whitespace-nowrap transition-all duration-200 ${
                  activeCategory === cat.slug
                    ? 'bg-primary-500 text-background-50'
                    : 'bg-background-100 text-foreground-600 hover:bg-background-200'
                }`}
              >
                <i className={`${cat.icon} text-base`}></i>
                {cat.name}
              </button>
            ))}
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4 md:gap-5" data-product-shop="">
            {filteredVideos.map((video) => (
              <Link
                key={video.id}
                to={`/category/${video.category}`}
                className="group rounded-xl overflow-hidden bg-background-100 hover:bg-background-200/70 transition-all duration-300"
              >
                <div className="relative w-full aspect-[3/4] overflow-hidden">
                  <img
                    src={video.image}
                    alt={video.title}
                    title={`${video.title} - 蘑菇视频官网`}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                  <div className="absolute top-2 left-2 px-2 py-0.5 rounded-md bg-primary-500 text-background-50 text-xs font-medium">
                    {video.rating}
                  </div>
                </div>
                <div className="p-3 md:p-4">
                  <h3 className="text-sm md:text-base font-semibold text-foreground-900 line-clamp-1 mb-1">
                    {video.title}
                  </h3>
                  <p className="text-xs text-foreground-500 line-clamp-1 mb-2">
                    {video.description}
                  </p>
                  <div className="flex items-center gap-3 text-xs text-foreground-500">
                    <span>{video.year}</span>
                    <span className="w-1 h-1 rounded-full bg-foreground-400"></span>
                    <span>{video.views}次播放</span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </main>
  );
}